define('SchemaOrg.Organization', [
    'SchemaOrg.BaseModule',
    'SC.Configuration',
    'underscore'
], function SchemaOrgOrganization(
    SchemaOrgBaseModule,
    Configuration,
    _
) {
	'use strict';

	function getSameAsConfiguration() {
		var sameAsConfig = Configuration.get('schemaOrg.sameAs', []);
		var parsedSameAs = _.isArray(sameAsConfig) ? sameAsConfig : [];

		return _.chain(parsedSameAs)
			.filter(function filterSameAs(value) {
				return _.isString(value) && !!value.replace(/^\s+|\s+$/g, '');
			})
			.map(function normalizeSameAs(value) {
				return value.replace(/^\s+|\s+$/g, '');
			})
			.value();
	}

	return _.extend({}, SchemaOrgBaseModule, {
		moduleType: 'organization',
		moduleMode: 'static',
		createJSONLD: function createJSONLD() {
			var logoImage = this.view.$('.header-logo-image').attr('src');
			return {
				'@context': 'https://schema.org',
				'@type': 'Organization',
				'url': location.origin,
				'logo': Configuration.get('schemaOrg.siteLogo', logoImage),
				'name': Configuration.get('schemaOrg.siteName', SC.ENVIRONMENT.siteSettings.displayname),
				'description': Configuration.get('schemaOrg.siteDescription', ''),
				'email': Configuration.get('schemaOrg.email', 'customerservice@applejack.com'),
				'sameAs': getSameAsConfiguration()
			};
		}
	});
});
